export const setPaymentPageTexts = (title: string, startDate: Date | null) => {
  localStorage.setItem('successText', title);

  if (startDate) {
    localStorage.setItem('startDate', startDate.toISOString());
  } else {
    localStorage.removeItem('startDate');
  }
};
